import * as Sentry from '@sentry/react';
import { originalConsole } from './setupConsoleOverrides';

class Logger {
  constructor() {
    this.context = {};
  }

  setContext(context = {}) {
    this.context = { ...this.context, ...context };
  }

  _logToConsole(level, message, context = {}) {
    const fullContext = { ...this.context, ...context };
    const base = originalConsole[level] || console.log; // fallback just in case
    base(`[${level.toUpperCase()}] ${message}`, fullContext);
  }

  log(message, context = {}) {
    this._logToConsole('log', message, context);
  }

  info(message, context = {}) {
    this._logToConsole('info', message, context);
  }

  warn(message, context = {}) {
    this._logToConsole('warn', message, context);
    Sentry.captureMessage(message, 'warning');
  }

  error(errorOrMessage, context = {}) {
    const isError = errorOrMessage instanceof Error;
    const message = isError ? errorOrMessage.message : errorOrMessage;

    this._logToConsole('error', message, context);

    if (isError) {
      Sentry.captureException(errorOrMessage);
    } else {
      Sentry.captureMessage(message, 'error');
    }
  }
}

export default Logger;
